import Navbar from "../components/Navbar";
import space from '../assets/Space.mp4';
import '../css/home.css';
import Initiatives from "../components/Initiatives";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import Landing from "../components/Landing";
import Funds from "../components/Funds";
import BackToTop from "../components/BackToTop";
import Gallery from "../components/Gallery";
import Slider from "../components/Slider";
import CommunitySection from "../components/Community";

export default function Home() {
    return (
        <>
            <Navbar />
            <Slider/>
            <Landing />
            <Gallery/>
            <Initiatives />
            <Funds />
            <CommunitySection/>
            <ContactForm />
            <Footer />
            <BackToTop />
        </>
    );
}